import { stripTags } from '@/lib/string';

type Column = {
	name: string;
	title: string;
};
export const mapColumnNamesToColumns = (selected: Column['name'][], columns: Column[]) =>
	selected.reduce<Column[]>((acc, name) => {
		const column = columns.find((column) => column.name === name);
		if (column) {
			acc.push({
				name: column.name,
				title: stripTags(column.title, true, false) as string,
			});
		}

		return acc;
	}, []);
